export const FILTERED = '[Filtered]';

const sensitiveParameter =
    /((?:^|[?&#;])(?:code|state|session_state|client_info|id_token|access_token|refresh_token|code_verifier|client_secret)=)[^&#\s]+/gi;

const maxDepth = 12;

/**
 * Replaces the value of every credential parameter in a URL, query string or text containing URLs.
 *
 * @ai-generated 2026-10-07T09:57:42+00:00 by malte.ulfers@tngtech.com using claude-opus-5-5
 */
export function scrubText(text: string): string {
    return text.replace(sensitiveParameter, `$1${FILTERED}`);
}

/**
 * Scrubs every string inside a Sentry payload in place and returns it, so it fits the `before*` hooks.
 *
 * @ai-generated 2026-10-07T09:57:42+00:00 by malte.ulfers@tngtech.com using claude-opus-5-5
 */
export function scrubCredentials<T>(payload: T): T {
    scrubValue(payload, 0);
    return payload;
}

// @ai-generated 2026-10-07T09:57:42+00:00 by malte.ulfers@tngtech.com using claude-opus-5-5
function scrubValue(value: unknown, depth: number): void {
    if (depth > maxDepth || value === null || typeof value !== 'object') {
        return;
    }

    const container = value as Record<string, unknown>;
    for (const key of Object.keys(container)) {
        const entry = container[key];
        if (typeof entry === 'string') {
            container[key] = scrubText(entry);
        } else {
            scrubValue(entry, depth + 1);
        }
    }
}
